/**
 * @generated SignedSource<<6d1ea130a2e61e576cffd375c90236b4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type cardFieldsList_updateWorkItemAllFieldTypesActionRenderer$data = {
  readonly fieldsByIdOrAlias: ReadonlyArray<{
    readonly __typename: string;
    readonly fieldId: string;
    readonly id: string;
    readonly type: string;
    readonly " $fragmentSpreads": FragmentRefs<"colorField_updateWorkItemAllFieldTypesActionRenderer" | "datePickerField_updateWorkItemAllFieldTypesActionRenderer" | "dateTimePickerField_updateWorkItemAllFieldTypesActionRenderer" | "flagField_updateWorkItemAllFieldTypesActionRenderer" | "genericField_updateWorkItemAllFieldTypesActionRenderer" | "labelsField_updateWorkItemAllFieldTypesActionRenderer" | "numberField_updateWorkItemAllFieldTypesActionRenderer" | "parentIssueField_updateWorkItemAllFieldTypesActionRenderer" | "priorityField_updateWorkItemAllFieldTypesActionRenderer" | "richTextField_updateWorkItemAllFieldTypesActionRenderer" | "singleLineTextField_updateWorkItemAllFieldTypesActionRenderer" | "singleSelectUserPickerField_updateWorkItemAllFieldTypesActionRenderer" | "sprintField_updateWorkItemAllFieldTypesActionRenderer" | "statusField_updateWorkItemAllFieldTypesActionRenderer" | "teamViewField_updateWorkItemAllFieldTypesActionRenderer" | "timeSpentField_updateWorkItemAllFieldTypesActionRenderer" | "timeTrackingField_updateWorkItemAllFieldTypesActionRenderer" | "usersField_updateWorkItemAllFieldTypesActionRenderer">;
  } | null> | null;
  readonly key: string;
  readonly " $fragmentType": "cardFieldsList_updateWorkItemAllFieldTypesActionRenderer";
};
export type cardFieldsList_updateWorkItemAllFieldTypesActionRenderer$key = {
  readonly " $data"?: cardFieldsList_updateWorkItemAllFieldTypesActionRenderer$data;
  readonly " $fragmentSpreads": FragmentRefs<"cardFieldsList_updateWorkItemAllFieldTypesActionRenderer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "fieldIdsOrAliases"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "sprintAris"
    }
  ],
  "kind": "Fragment",
  "name": "cardFieldsList_updateWorkItemAllFieldTypesActionRenderer",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "idsOrAliases",
          "variableName": "fieldIdsOrAliases"
        },
        {
          "kind": "Literal",
          "name": "ignoreMissingFields",
          "value": true
        }
      ],
      "kind": "LinkedField",
      "name": "fieldsByIdOrAlias",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__typename"
        },
        {
          "kind": "ScalarField",
          "name": "id"
        },
        {
          "kind": "ScalarField",
          "name": "fieldId"
        },
        {
          "kind": "ScalarField",
          "name": "type"
        },
        {
          "kind": "FragmentSpread",
          "name": "singleLineTextField_updateWorkItemAllFieldTypesActionRenderer"
        },
        {
          "kind": "FragmentSpread",
          "name": "richTextField_updateWorkItemAllFieldTypesActionRenderer"
        },
        {
          "kind": "FragmentSpread",
          "name": "singleSelectUserPickerField_updateWorkItemAllFieldTypesActionRenderer"
        },
        {
          "kind": "FragmentSpread",
          "name": "usersField_updateWorkItemAllFieldTypesActionRenderer"
        },
        {
          "kind": "FragmentSpread",
          "name": "statusField_updateWorkItemAllFieldTypesActionRenderer"
        },
        {
          "kind": "FragmentSpread",
          "name": "priorityField_updateWorkItemAllFieldTypesActionRenderer"
        },
        {
          "kind": "FragmentSpread",
          "name": "labelsField_updateWorkItemAllFieldTypesActionRenderer"
        },
        {
          "kind": "FragmentSpread",
          "name": "flagField_updateWorkItemAllFieldTypesActionRenderer"
        },
        {
          "kind": "FragmentSpread",
          "name": "datePickerField_updateWorkItemAllFieldTypesActionRenderer"
        },
        {
          "kind": "FragmentSpread",
          "name": "dateTimePickerField_updateWorkItemAllFieldTypesActionRenderer"
        },
        {
          "kind": "FragmentSpread",
          "name": "parentIssueField_updateWorkItemAllFieldTypesActionRenderer"
        },
        {
          "kind": "FragmentSpread",
          "name": "numberField_updateWorkItemAllFieldTypesActionRenderer"
        },
        {
          "kind": "FragmentSpread",
          "name": "timeTrackingField_updateWorkItemAllFieldTypesActionRenderer"
        },
        {
          "kind": "FragmentSpread",
          "name": "timeSpentField_updateWorkItemAllFieldTypesActionRenderer"
        },
        {
          "kind": "FragmentSpread",
          "name": "colorField_updateWorkItemAllFieldTypesActionRenderer"
        },
        {
          "kind": "FragmentSpread",
          "name": "teamViewField_updateWorkItemAllFieldTypesActionRenderer"
        },
        {
          "kind": "FragmentSpread",
          "name": "genericField_updateWorkItemAllFieldTypesActionRenderer"
        },
        {
          "args": [
            {
              "kind": "Variable",
              "name": "sprintAris",
              "variableName": "sprintAris"
            }
          ],
          "kind": "FragmentSpread",
          "name": "sprintField_updateWorkItemAllFieldTypesActionRenderer"
        }
      ]
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "45bc75363da5da36e5c66b99b003fdf3";

export default node;
